import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../App';
import { CheckText } from '../../components/common/CheckText';
import { Flexed } from '../../styles/GlobalComponents';
import { PackageRankMyProgressModel } from './Ranking.types';
import { colors } from '../../styles/GlobalStyles';

export const QualifiedPartner = ({
  rank
}: {
  rank: PackageRankMyProgressModel;
}) => {
  const { t } = useTranslation('ranking');

  if (rank.name === 'Qualified Partner') {
    return (
      <Flexed between rowSM justifyStartSM>
        <CheckText
          text={t('qualified_partner.text1')}
          checked={rank.isRegisteredMember}
          checkColor={colors.primary900}
        />

        <CheckText
          text={t('qualified_partner.text2')}
          checked={rank.hasPaidHub}
          checkColor={colors.primary900}
        />
        <CheckText
          text={'1x Active direct - Left Leg'}
          checked={rank.hasPartnerWithPaidPackageInLeftLeg}
          checkColor={colors.primary900}
        />
        <CheckText
          text={'1x Active direct - Right Leg'}
          checked={rank.hasPartnerWithPaidPackageInRightLeg}
          checkColor={colors.primary900}
        />
        {/* <CheckText
          text={'3 Active Directs'}
          checked={
            rank.numOfDirectsWithPaidPackageInLeftLeg +
              rank.numOfDirectsWithPaidPackageInRightLeg >
            2
          }
          checkColor={colors.primary900}
        /> */}
      </Flexed>
    );
  } else return null;
};
